import { ENVIRONMENT } from "./environment"

const fb = {
	DEVELOPMENT: {
		credentials: {
			apiKey: "AIzaSyAQvg0FGdIpkC95dhFCBZICQzkrLL5B7wo",
			authDomain: "cams-dev.firebaseapp.com",
			databaseURL: "https://cams-dev.firebaseio.com",
			projectId: "cams-dev",
			storageBucket: "cams-dev.appspot.com",
			messagingSenderId: "193289006537"
		}
	},
	ACCEPTANCE: {
		credentials: {
			apiKey: "AIzaSyCjvq0N1_5kw8Uf8eoQGur2FYdLt4Hwcx4",
			authDomain: "cams-acc.firebaseapp.com",
			databaseURL: "https://cams-acc.firebaseio.com",
			projectId: "cams-acc",
			storageBucket: "cams-acc.appspot.com",
			messagingSenderId: "557463216781"
		}
	},
	PRODUCTION: {
		credentials: {
			apiKey: "AIzaSyAWmRikUXtEfQ_TyjrwxdhScMSG3i4tSSk",
			authDomain: "cams-prd.firebaseapp.com",
			databaseURL: "https://cams-prd.firebaseio.com",
			projectId: "cams-prd",
			storageBucket: "cams-prd.appspot.com",
			messagingSenderId: "886390965074"
		}
	}
};

export const firebase = fb[ENVIRONMENT]


// WEBPACK FOOTER //
// ./src/config/firebase.js